/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MaritimeWarningSettings
 */
export interface MaritimeWarningSettings {
    /**
     * 
     * @type {boolean}
     * @memberof MaritimeWarningSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaritimeWarningSettings
     */
    'enabled_domains': Array<MaritimeWarningSettingsEnabledDomainsEnum>;
    /**
     * 
     * @type {string}
     * @memberof MaritimeWarningSettings
     */
    'toolbar_label_override': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaritimeWarningSettings
     */
    'title_override': string | null;
    /**
     * 
     * @type {string}
     * @memberof MaritimeWarningSettings
     */
    'description_override': string | null;
}

export const MaritimeWarningSettingsEnabledDomainsEnum = {
    Kust: 'kust',
    Noordzee: 'noordzee'
} as const;

export type MaritimeWarningSettingsEnabledDomainsEnum = typeof MaritimeWarningSettingsEnabledDomainsEnum[keyof typeof MaritimeWarningSettingsEnabledDomainsEnum];


